import AttachFileRounded from '@mui/icons-material/AttachFileRounded';
import type { Column } from '../../components/DataTable';
import { Paperclip } from './Paperclip';

/**
 * A narrow paper-clip column for a list, shown only when some row on the page has files (spread it
 * into the columns: `[...columns, ...filesColumn(counts)]`).
 */
export function filesColumn<T extends { id: string }>(counts: Record<string, number>): Column<T>[] {
  if (Object.keys(counts).length === 0) return [];
  return [
    {
      key: 'files',
      header: (
        <AttachFileRounded
          aria-label="Files"
          sx={{ fontSize: '1rem', transform: 'rotate(45deg)' }}
        />
      ),
      align: 'center',
      width: 48,
      render: (r) => <Paperclip count={counts[r.id]} />,
    },
  ];
}
